/* global madCustomerCard */

import domReady from '@wordpress/dom-ready';
import { setInputFields } from '../../utils/customer-card-utility';
domReady( async () => {
	const customerCard = document.querySelector( 'form.checkout #kundkort' );
	const onCardChange = () => {
		const userId = +customerCard.value;

		if ( ! madCustomerCard ) {
			return;
		}

		setInputFields( madCustomerCard[ userId ], customerCard.closest( 'form' ) );
	};

	if ( ! customerCard ) {
		return;
	}

	// eslint-disable-next-line no-console
	customerCard.addEventListener( 'change', onCardChange );
} );
